module.exports = __webpack_public_path__ + "static/media/blocks.062754dc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/blocks.mp4
// module id = 358
// module chunks = 0